import { type components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { VERIFY_CURRENT_EMAIL_REQUEST } from '../../contracts/keys';
import { requestCurrentEmailVerification } from '../api/email-change';

export type VerifyCurrentEmailResponse =
  components['schemas']['VerifyCurrentEmailResponse'];

export interface UseVerifyCurrentEmailRequestOptions {
  onSuccess?: (data: VerifyCurrentEmailResponse) => void;
  onError?: (error: unknown) => void;
}

export function useVerifyCurrentEmailRequest(
  options?: UseVerifyCurrentEmailRequestOptions
) {
  return useMutation({
    mutationKey: [VERIFY_CURRENT_EMAIL_REQUEST],
    mutationFn: async () => {
      const response = await requestCurrentEmailVerification();
      return response.data;
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
